module.exports = __webpack_public_path__ + "img/trade-service-parts-display-chevy.c6023f13.png";